import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import styled from "styled-components";
import { fetchCustomer, modifyCustomer, selectCustomerById } from "../common/slices/customer";
import { selectActive } from "../common/slices/location";
import { BlackButton, ButtonBase, LightButton } from "./Buttons";
import FormTextInput from "./FormTextInput";
import Modal from "./Modal";
import Row from "./Row";
import { H1, P, P2 } from "./Typography";
import { ErrorContext } from "../ErrorContext";

const Attribute = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const ModalEditCustomer = ({ customerId, onClose }) => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const locationId = useSelector(selectActive);
    const customer = useSelector(state => selectCustomerById(state, customerId));

    useEffect(() => {
        (async () => {
            try {
                if (customerId && locationId) {
                    await dispatch(fetchCustomer(customerId, locationId));
                }
            } catch (ex) {
                errorContext.setError({ errorMessage: "Failed to get customer", forSupport: ex.message });
            }
        })()
    }, [customerId, locationId])

    const {
        control,
        formState: { errors, isSubmitting, isValid },
        handleSubmit
    } = useForm({
        values: customer,
    })

    const formProps = { control, errors, locationId }

    const onSave = async (data) => {
        try {
            await dispatch(modifyCustomer(data));
            onClose();
        } catch (ex) {
            errorContext.setError({ errorMessage: "Failed to save customer", forSupport: ex.message });
        }
    }

    return (
        <Modal show size="60%" zindex='1200'>
            <Row>
                <H1>Customer</H1>
                <ButtonBase onClick={onClose} style={{ marginLeft: 'auto' }}><FaTimes size='16px' color="#000" /></ButtonBase>
            </Row>

            <Row>
                <Attribute>
                    <P2>QuickBooks ID</P2>
                    <P>{customer?.id}</P>
                </Attribute>
                <Attribute>
                    <P2>Location</P2>
                    <P>{customer?.location?.name}</P>
                </Attribute>
            </Row>
            <FormTextInput {...formProps} name="name" label="Full Name" placeholder="Enter full name" rules={{ required: true }} />
            <Row>
                <BlackButton onClick={handleSubmit(onSave)} disabled={isSubmitting || !isValid}>Save</BlackButton>
                <LightButton onClick={onClose} disabled={isSubmitting}>Cancel</LightButton>
            </Row>
        </Modal>
    );
};

export default ModalEditCustomer;
